import React from 'react';
import { styled } from '@compiled/react';

import type { ContentClassificationMetadata } from '../hooks/useContentClassification.ts';

import { Box } from '@atlaskit/primitives/compiled';
import { ContentTypeClassification } from '../ContentTypeClassification/ContentTypeClassification.tsx';
import { EditorContentClassificationTag } from '../ContentClassificationLevel/EditorContentClassificationTag.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ClassificationTagPlaceholder = styled.div({
	height: '26px',
});

export interface EditorClassificationTagWrapperProps {
	isDataClassificationEnabledForOrg: boolean;
	spaceKey: string;
	contentId: string;
	contentType: string;
	contentClassificationMetadata: ContentClassificationMetadata;
	hasEditPermission: boolean;
	isLivePage?: boolean;
	userOffline: boolean;
	// Note: this comes from the props, rather than the hook in scope,
	// so we can use it in the LoadableAfterPaint `loading` component for SSR
	shouldRenderPlaceholder?: boolean;
}

export const EditorClassificationTagWrapper = ({
	isDataClassificationEnabledForOrg,
	spaceKey,
	contentId,
	contentType,
	contentClassificationMetadata,
	hasEditPermission,
	isLivePage,
	userOffline,
	shouldRenderPlaceholder,
}: EditorClassificationTagWrapperProps) => {
	if (!isDataClassificationEnabledForOrg) return null;
	return (
		<>
			{isLivePage ? (
				<Box>
					<ContentTypeClassification
						spaceKey={spaceKey}
						contentId={contentId}
						contentType={contentType}
						contentClassificationMetadata={contentClassificationMetadata}
						readOnly={!hasEditPermission}
					/>
				</Box>
			) : (
				<div data-testid="content-classification-tag">
					<EditorContentClassificationTag
						contentId={contentId}
						contentType={contentType}
						contentClassificationMetadata={contentClassificationMetadata}
						isEditMode
						spaceKey={spaceKey}
						userOffline={userOffline}
					/>
				</div>
			)}
			{shouldRenderPlaceholder && <ClassificationTagPlaceholder />}
		</>
	);
};
